import styled from 'styled-components';
import Headline from '@klv/atoms/headline';
import type { ITransientProps } from '../types';

export const StatCopy = styled(Headline)<ITransientProps>`
  color: ${({ theme, $background }) => theme.stat[$background].subcopy};
`;

export const StatHeadline = styled(Headline)<ITransientProps>`
  color: ${({ theme, $background }) => theme.stat[$background].subHeadline};
  ${({ theme }) => theme.stat.font.fontFace};
  font-size: ${({ theme }) => theme.stat.font.fontSize};
  letter-spacing: -1px;
  line-height: ${({ theme }) => theme.stat.font.lineHeight};
`;

export const StyledStat = styled.article<ITransientProps>`
  border-left: ${({ theme, $background }) => theme.stat[$background].border} 2px solid;
  grid-column: 2 / -2;
  padding-left: 1rem;

  ${({ theme }) => theme.screenSize.s576.mediaQuery} {
    padding-left: 4rem;
  }

  &:nth-of-type(even) {
    ${({ theme }) => theme.screenSize.s576.mediaQuery} {
      grid-column: 7 / -2;
    }
  }

  &:nth-of-type(odd) {
    ${({ theme }) => theme.screenSize.s576.mediaQuery} {
      grid-column: 2 / 7;
    }
  }
`;
